"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette;
  return {
    productTeaser: {
      color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.text) === null || _theme$palette === void 0 ? void 0 : _theme$palette.secondary,
      display: "block",
      paddingBottom: theme.spacing(2)
    },
    image: {
      position: "relative"
    },
    fallbackImage: {
      display: "flex",
      minHeight: "100%",
      paddingBottom: "109.375%",
      position: "relative",
      "& .mco-fallback-image": {
        left: 0,
        position: "absolute",
        top: 0
      }
    },
    bookmark: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1)
    },
    content: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    title: {
      fontSize: "1.125rem",
      fontWeight: theme.typography.fontWeightBold
    },
    description: {
      fontSize: "0.875rem",
      marginTop: theme.spacing(0.5)
    },
    attributes: {
      fontSize: "0.875rem",
      lineHeight: 1.28,
      marginTop: theme.spacing(0.5),
      "& span": {
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    price: {
      marginTop: theme.spacing(1)
    },
    tags: {
      bottom: 0,
      left: 0,
      position: "absolute"
    }
  };
});
var _default = exports.default = styles;